import { createContext, useContext, type Context } from 'react';

/**
 * Context for the current menu section. It holds a unique ID for the section, used for associating the section heading
 * as an accessible label for the group.
 */
export const MenuSectionContext: Context<string | null> = createContext<string | null>(null);

export const useMenuSectionContext = (): string => {
	const context = useContext(MenuSectionContext);
	if (!context) {
		throw new Error('useMenuSectionContext must be used within a MenuSection');
	}
	return context;
};
